import { useEffect, useMemo, useState } from 'react';
import Select from 'react-select';
import { getContentPlaylists } from '../Screen/utils';
import playlistPhoto from '../../images/photos/interactivity.png';

import pauseIcon from '../../images/icons/screens/pause.svg';
import playlistIcon from '../../images/icons/screens/playlist.svg';

const selectStyles = {
    container: base => ({ ...base, flex: 1, minWidth: 200, maxWidth: 320 }),
    control: base => ({
        ...base,
        border: '1px solid #e2e8f0',
        boxShadow: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
    }),
    indicatorSeparator: () => ({ display: 'none' }),
    option: (base, state) => ({
        ...base,
        cursor: 'pointer',
        color: state.isDisabled ? '#919191' : 'inherit',
    }),
};

const JourneyPlaylistConfiguration = ({ playlist, onChange, customer, permissions }) => {
    const [contentPlaylists, setContentPlaylists] = useState([]);

    useEffect(() => {
        getContentPlaylists(customer.id).then(data => {
            if (Array.isArray(data)) setContentPlaylists(data);
        });
    }, [customer.id]);

    const mode = playlist?.journeyPlaylistShortCode ? 'playlist' : 'standby';
    const playlistOptions = contentPlaylists.map(pl => ({ label: pl.label, value: pl.shortCode }));

    const isEditable = useMemo(() => {
        let retval = false;
        if (
            playlist?.id &&
            playlist?.location?.id in permissions['journey'] &&
            playlist?.location?.id in permissions['journeyPlaylistConfiguration'] &&
            permissions['journeyPlaylistConfiguration'][playlist.location.id].includes('editor')
        ) {
            retval = true;
        }

        return retval;
    }, [playlist]);

    return (
        <div className="JourneyPlaylistConfiguration">
            <div className="photo">
                <img src={playlistPhoto} alt="playlists" />
            </div>
            <div className="playlist-config">
                <h3 className="config-title">Playlists</h3>
                <h4>Search Screen Messaging</h4>
                <p className="config-description">
                    To change the content running on the Journey search screen (homepage), please specify
                    what playlist should be shown. New playlists can be created using the "Playlists" section in
                    the navigation bar on the left side of the screen.
                </p>

                <div
                    className={`radio-option${mode === 'standby' ? ' selected' : ''}`}
                    onClick={() => isEditable ? onChange('journeyPlaylistShortCode', null) : null}
                    style={!isEditable ? {pointerEvents: "none", cursor: "default", color: "rgb(145, 145, 145)"} : null}
                >
                    <input
                        type="radio"
                        readOnly
                        checked={mode === 'standby'}
                        onChange={() => onChange('journeyPlaylistShortCode', null)}
                        disabled={!isEditable}
                    />
                    <img src={pauseIcon} alt="standby" className="option-icon" />
                    <strong>Standby</strong>&nbsp;(default)
                </div>
                <div className="option-desc">Turns off all content and shows a "Content not available" message.</div>

                <div
                    className={`radio-option${mode === 'playlist' ? ' selected' : ''}`}
                    onClick={() => {
                        if (mode !== 'playlist' && playlistOptions.length > 0) {
                            onChange('journeyPlaylistShortCode', playlistOptions[0].value);
                        }
                    }}
                    style={!isEditable ? {pointerEvents: "none", cursor: "default", color: "rgb(145, 145, 145)"} : null}
                >
                    <input
                        type="radio"
                        readOnly
                        checked={mode === 'playlist'}
                        onChange={() => {}}
                        disabled={!isEditable}
                    />
                    <img src={playlistIcon} alt="playlist" className="option-icon" />
                    <div className="option-content">
                        <strong>Playlist:</strong>
                        <Select
                            styles={selectStyles}
                            options={playlistOptions}
                            value={playlistOptions.find(o => o.value === playlist?.journeyPlaylistShortCode) || null}
                            onChange={opt => onChange('journeyPlaylistShortCode', opt.value)}
                            placeholder="Select a playlist..."
                            onClick={e => e.stopPropagation()}
                            isDisabled={!isEditable}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default JourneyPlaylistConfiguration;
